export const utilityColors = {
  utilityBackground: '#FAF5F0',
  utilityInformationBackground: '#EBE9F1',
  utilityText: '#341F73',
  utilityWhite: '#FFF',
} as const;
